// Pure helpers behind the Vehicle Info list column (estimates,
// invoices, ADAS reports). Kept free of React so they can be unit tested.

// Normalises a record's vehicles to an array; tolerates a missing field and
// the single-object shape an $unwind'd search row used to carry.
export const getVehicles = record => {
  const vehicles = record && record.vehicles
  if (Array.isArray(vehicles)) return vehicles.filter(Boolean)
  return vehicles && typeof vehicles === 'object' ? [vehicles] : []
}

// First vehicle plus how many others the document carries.
export const summarizeVehicles = vehicles => {
  const list = Array.isArray(vehicles) ? vehicles.filter(Boolean) : []
  return {
    vehicle: list[0] || null,
    extraCount: Math.max(list.length - 1, 0),
  }
}


// Legacy S3 vehicle photos live in the mobiletechassets bucket; the colorCropped
// variant has the EVOX watermark cropped off. EVOX URLs are already complete.
const LEGACY_IMAGE_BASE = 'https://mobiletechassets.s3.us-east-2.amazonaws.com/colorCropped/'

// Resolves a vehicle's image the same way the admin portal's VehicleInfo cell does:
// { url, isPlaceholder } — url is null when there is no image, so the caller renders
// its placeholder silhouette instead.
export const getVehicleImageInfo = image => {
  if (!image || typeof image !== 'string') return { url: null, isS3: false, isPlaceholder: true }
  if (image.startsWith('http://') || image.startsWith('https://')) return { url: image, isS3: false, isPlaceholder: false }
  // Legacy S3 photos carry the EVOX watermark bottom-right; isS3 lets the cell crop it.
  return { url: `${LEGACY_IMAGE_BASE}${image.split('/').pop()}`, isS3: true, isPlaceholder: false }
}
